export default __webpack_public_path__ + "static/media/photo--lg--136.1810520e.jpg";